import { axiosInstance } from "../config/axios";

const handlerEnabled = true;

const endpoint = "search-models/";

export const create = async (params) => {
	try {
		const res = await axiosInstance.post(endpoint, params, {
			handlerEnabled,
		});

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getAll = async (filters) => {
	try {
		const res = await axiosInstance.get(endpoint, {
			params: filters,
			handlerEnabled,
		});

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const update = async (id, params) => {
	try {
		const res = await axiosInstance.put(`${endpoint}${id}/`, params);
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const remove = async (id) => {
	try {
		const res = await axiosInstance.delete(`${endpoint}${id}`);

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};
